import React, { useEffect, useState } from 'react'
import './DocsGallery.sass'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'
import getDoc from '../../utils/db/getDoc'
import { isEmpty } from 'lodash'

function DocsGallery() {
  const [data, setData] = useState(null)

  useEffect(() => {
    getDoc({
      path: 'docs',
      docId: 'gallery',
    }).then((res) => setData(res))
  }, [])

  return (
    <div className="DocsGallery">
      <div className="DocsGallery-Container DefaultContainer">
        <SectionTitle title={'Дозвільні документи'} />
        <div className="DocsGallery-Tiles">
          {!isEmpty(data) &&
            data.photos.map((p) => (
              <a href={p.publicUrl} data-fancybox>
                <img src={p.publicUrl} alt="" className="GalleryPhoto" />
              </a>
            ))}
        </div>
      </div>
    </div>
  )
}

export default DocsGallery
